var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "button-group" },
    [
      _c("GroupIconButton", {
        attrs: {
          iconProp: "file",
          urlProp:
            "//pdfcrowd.com/url_to_pdf/?use_print_media=1&url=" +
            encodeURIComponent(_vm.customUrlProp) +
            "&pdf_name=Zehnder-configurator&width=210mm&height=297mm&hmargin=10mm&vmargin=10mm",
          labelProp: "Save my selection",
          colourProp: "purple"
        }
      }),
      _vm._v(" "),
      _c("GroupIconButton", {
        attrs: {
          iconProp: "heart",
          urlProp:
            "/index.php?p=actions/wishlist/items/add&elementId=" +
            _vm.elementIdProp +
            "&fields[config]=" +
            _vm.configProp.replace(/^#/, "") +
            "&fields[wishlistFinishId]=" +
            _vm.finishIdProp +
            "&fields[wishlistValveId]=" +
            _vm.valveIdProp +
            "&fields[wishlistSupplementalHeater]=" +
            _vm.suppHeaterProp +
            "&fields[wishlistView]=" +
            _vm.viewProp +
            "&fields[wishlistZoom]=" +
            _vm.zoomProp +
            "&fields[wishlistBackground]=" +
            _vm.backgroundProp +
            "&options[optionhash]=" +
            _vm.elementIdProp +
            "." +
            _vm.finishIdProp +
            "." +
            _vm.valveIdProp +
            "." +
            _vm.suppHeaterProp,
          labelProp: "Add to my favourites",
          colourProp: "hotpink"
        }
      }),
      _vm._v(" "),
      _c("GroupButton", {
        attrs: {
          urlProp: "/where-to-buy",
          labelProp: "Where to buy",
          colourProp: "blue"
        }
      }),
      _vm._v(" "),
      _vm.dealerAreaLinkProp
        ? _c("GroupButton", {
            attrs: {
              urlProp: _vm.dealerAreaLinkProp,
              labelProp: "Downloadable assets",
              colourProp: "blue"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }